var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-1.3 0h60v40h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#df0000",
    d: "M-1.3 0h60v20h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.5 3.4a7 7 0 0 0 0 13.7 7.2 7.2 0 1 1 0-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.4 9.2.4 1.2-1-.7-1.1.7.4-1.2L9 8.4h1.3l.4-1.3.5 1.3h1.3zm1.5 4.3.4 1.3-1-.8-1.2.8.4-1.3-1-.8h1.3l.4-1.2.4 1.2H14zm4.9 0 .4 1.2L17 14l-1 .7.3-1.2-1-.8h1.3l.4-1.3.4 1.3h1.3zm1.4-4.3.4 1.2-1-.7-1.1.7.4-1.2-1.1-.8H18l.4-1.3.4 1.3h1.4zm-3.9-2.9.5 1.3-1.1-.8-1.1.8.4-1.3-1-.8h1.3l.4-1.2.4 1.2h1.3z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/sg.ca773e3be999cb8f64afb76ee9dbf81a.svg";
export { ForwardRef as ReactComponent };